import React from "react";

import ImageButton from "../core/ImageButton/ImageButton";
import BackArrow from "@components/refactored-survey/images/back-arrow.svg";
import i18n from "src/locales";
import BackButtonWithText from "./BackButtonWithText";
import WhiteBackArrow from "./images/backIcon.svg";
import CalorieBackArrow from "./images/CalorieBackIcon.svg";
import CalorieWhiteBackArrow from "./images/CalorieBackIconWhite.svg";

export type BackArrowColor = "white" | "default";
export type BackArrowType = "noom" | "calorie";

type Props = {
  onClickBack: () => void;
  disabled?: boolean;
  text?: string;
  alt?: string;
  backArrowColor?: BackArrowColor;
  backArrowType?: BackArrowType;
};

const BackButtonByColorMap = {
  noom: {
    white: WhiteBackArrow,
    default: BackArrow,
  },
  calorie: {
    white: CalorieWhiteBackArrow,
    default: CalorieBackArrow,
  },
};

export default function BackButton({
  text,
  alt = i18n.t("survey:btnBackAlt"),
  disabled,
  onClickBack,
  backArrowColor = "default",
  backArrowType = "noom",
}: Props) {
  if (disabled) {
    return null;
  }

  if (text) {
    return <BackButtonWithText onClickBack={onClickBack} text={text} />;
  }

  const backArrow = BackButtonByColorMap[backArrowType][backArrowColor];

  return (
    <ImageButton
      onClick={() => onClickBack()}
      src={backArrow}
      alt={alt}
      data-cy="back-button"
      css={{
        textAlign: "left",
        padding: "7px 10px 7px 10px",
      }}
    />
  );
}
